module.exports = __webpack_public_path__ + "img/img_deal_bnr_00.db274e9d.png";